import { RouteObject } from 'react-router-dom'
import { LoadedPageContent, PageLoadingSupport } from '../../../common/app'
import { default as Workforce } from '.'

const basePath = '/time/workforce'
export const workforceRoutes: RouteObject[] = [
  {
    path: `${basePath}/staff-members`,
    element: (
      <LoadedPageContent
        title={'Manage Staff Members'}
        displayLeftTitle={false}
      >
        <Workforce.StaffMembers.Component />
      </LoadedPageContent>
    ),
    loader: Workforce.StaffMembers.Loader,
  },
  {
    path: `${basePath}/staff-members/:staffMemberId`,
    element: (
      <LoadedPageContent>
        <Workforce.EditStaffMember.Component />
      </LoadedPageContent>
    ),
    loader: Workforce.EditStaffMember.Loader,
  },
  {
    path: `${basePath}/staff-members/add`,
    element: (
      <LoadedPageContent title={'New Staff Member'} displayLeftTitle={false}>
        <Workforce.AddStaffMember.Component />
      </LoadedPageContent>
    ),
    loader: Workforce.AddStaffMember.Loader,
  },
  {
    path: '/employee/request-information',
    element: (
      <PageLoadingSupport>
        <Workforce.RequestEmployeeInformation.Component />
      </PageLoadingSupport>
    ),
    loader: Workforce.RequestEmployeeInformation.Loader,
  },
  {
    path: '/employee/unavailability/status',
    element: (
      <PageLoadingSupport>
        <Workforce.UnavailabilityStatus.Component />
      </PageLoadingSupport>
    ),
    loader: Workforce.UnavailabilityStatus.Loader,
  },
  {
    path: '/employee/leave/status',
    element: (
      <PageLoadingSupport>
        <Workforce.LeaveRequestStatus.Component />
      </PageLoadingSupport>
    ),
    loader: Workforce.LeaveRequestStatus.Loader,
  },
]
